module.exports = __webpack_public_path__ + "static/media/ChinguProd1.802abcd1.png";